window.customElements.define(
    "nag-dialog",
    class extends HTMLElement {
        private readonly dialog: HTMLDialogElement | null;

        constructor() {
            super();

            this.dialog = this.querySelector("dialog");
        }

        connectedCallback() {
            if (this.getAttribute("no-close")) {
                this.dialog?.addEventListener(
                    "cancel",
                    (event) => {
                        event.preventDefault();
                    },
                );
            }

            if (this.hasAttribute("show-after")) {
                setTimeout(
                    () => this.dialog?.showModal(),
                    parseInt(this.getAttribute("show-after") ?? "5000", 10),
                );
            } else {
                document.documentElement.addEventListener("mouseleave", () => this.dialog?.showModal());
            }
        }
    },
);
